import Popup from './components/bobtv-neo/Popup/index';
import LoggedOutPopup from './components/bobtv-neo/LoggedOutPopup/index';
import PostPaymentPopup from './components/bobtv-neo/PostPaymentPopup/index';
import UnsupportedBrowserPopup from './components/bobtv-neo/UnsupportedBrowserPopup/index';
import LoginErrorPopup from './components/bobtv-neo/LoginErrorPopup/index';
import PpvInfoPopup from './components/bobtv-neo/PpvInfoPopup/index';
import Registry from './registry/index';

import {
    LOGOUT_NOTIFICATION,
    MEMBER_TYPE_CHANGE_NOTIFICATION
} from './constants/serviceMessage';

import {
    TOO_MANY_USERS_REASON,
    BLACKLISTED_REASON,
    BLOCKED_REASON,
    EXCLUDED_REASON,
    NONEXISTENT_ROOM_REASON,
    INVALID_GENDER_REASON,
    PAYMENT_REQUIRED,
    INSUFFICIENT_FUNDS
} from "./constants/chatInterface";

function addLogoutNotificationHandling() {
    let chatInterface = Registry.get('chatInterface');
    chatInterface.onServiceMessage(function(ServiceMessage) {
        // todo: move to redux's state
        if (ServiceMessage.type === LOGOUT_NOTIFICATION) {
            LoggedOutPopup.open({reloginUrl: ServiceMessage.data.chat_url});
        }

        if (ServiceMessage.type === MEMBER_TYPE_CHANGE_NOTIFICATION) {
            PostPaymentPopup.open();
        }
    });
}


function addLoginErrorHandling() {
    let chatInterface = Registry.get('chatInterface');

    chatInterface.onBaseLibNotLoaded(function () {
        LoginErrorPopup.open({message: 'base_lib_not_loaded'});
    });

    chatInterface.onLoginError(function (Code, Reason, Data) {
        if (Reason === TOO_MANY_USERS_REASON) {
            let chatUrlSecondary = chatInterface.getSecondaryRoomURL(),
                chatroomNameSecondary = chatInterface.getSecondaryRoomName(),
                chatroomName = chatInterface.getChatRoomName();

            LoginErrorPopup.open({chatUrlSecondary, chatroomNameSecondary, chatroomName});
        }

        if (Reason === BLOCKED_REASON) {
            LoginErrorPopup.open({message: 'excluded_blocked_popup', closeButton: true, ...Data});
        }

        if (Reason === EXCLUDED_REASON) {
            LoginErrorPopup.open({message: Data.room ? 'excluded_room_popup' : 'excluded_blocked_popup', closeButton: true, ...Data});
        }

        if (Reason === BLACKLISTED_REASON) {
            LoginErrorPopup.open({message: 'blacklisted_popup', mainRoomButton: true, ...Data});
        }

        if (Reason === NONEXISTENT_ROOM_REASON) {
            LoginErrorPopup.open({message: 'nonexistent_room_popup', mainRoomButton: true, ...Data});
        }

        if (Reason === INVALID_GENDER_REASON) {
            LoginErrorPopup.open({message: 'invalid_gender_for_gays_room', mainRoomButton: true, ...Data});
        }
        
        if (Reason === INSUFFICIENT_FUNDS) {
            //LoginErrorPopup.open({message: 'insufficient_funds', mainRoomButton: true, ...Data});
            PpvInfoPopup.open({reason: INSUFFICIENT_FUNDS, ...Data});
        }

        if (Reason === PAYMENT_REQUIRED) {
            PpvInfoPopup.open({reason: PAYMENT_REQUIRED, ...Data});
        }

    });

    chatInterface.onRoomSubscriptionPaymentFailed(function(Data) {
        PpvInfoPopup.open({reason: Data.error_msg, ...Data});
    });

    chatInterface.onLoginSuccess(function() {

        LoginErrorPopup.close();

    });
}

function browserCheckPopup() {
    var supportedBrowserRE = new RegExp("(?:Firefox|Safari)","i"),
        edgeRE = new RegExp("Edge"),
        ua = navigator.userAgent;

    //console.log("ua:" + ua + "; " + (supportedBrowserRE ? "supported" : "NOT supported"));

    if (!supportedBrowserRE.test(ua) || edgeRE.test(ua)) {
        UnsupportedBrowserPopup.open();
    }

    if (/Firefox\/60/.test(ua) || /Firefox\/52/.test(ua)) {
        UnsupportedBrowserPopup.open({firefoxESR: true});
    }

    var isiOS = /iP(ad|hone)/i.test(ua);
    var isSafari = /WebKit/i.test(ua) && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(ua));

    if(isiOS && !isSafari) {
        UnsupportedBrowserPopup.open();
    }

    var versions;

    if(isiOS) {
        versions = (new RegExp("OS ([0-9]+)\_([0-9]+)", "ig")).exec(ua);
        if(versions && (versions[1] < 12 || (versions[1] == 12 && versions[2] < 2))) {
            UnsupportedBrowserPopup.open();
        }

    }

}

export function preRender() {
    Popup.initRootElement();
}

function registerServiceWorker () {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', function() {
            navigator.serviceWorker.register(
                '/firebase-messaging-sw.js',
                { scope: '/' })
            .then(function(registration) {
                // Registration was successful
                console.log('ServiceWorker registration successful with scope: ', registration.scope);
            }, function(err) {
                // registration failed :(
                console.log('ServiceWorker registration failed: ', err);
            }).catch(function(err) {
                console.log(err)
            });

            navigator.serviceWorker.getRegistrations().then(function(registrations) {
                for(let registration of registrations) {
                    if(registration.active.scriptURL.match(new RegExp("service\-worker\.js$"))){
                        console.log("Unregistering SW " + registration.active.scriptURL);
                        registration.unregister();
                    } else {
                        console.log("URL does not match " + registration.active.scriptURL);
                    }

                }
            }).catch(function(err) {
                console.log('Service Worker de-registration failed: ', err);
            });
        });
    } else {
        console.log('service worker is not supported');
    }
}

// a function that is called after application component is rendered
export function postRender() {
    addLoginErrorHandling();
    addLogoutNotificationHandling();
    browserCheckPopup();
    registerServiceWorker();
}


// WEBPACK FOOTER //
// ./src/hooks.js